import { ChannelShowMessenger } from "component/app/channelTalk";
import { BtnBox, BtnItem } from "component/basic/btns";
import { useLocation, useNavigate } from "react-router-dom";

//footer
function FooterLink(data){

    return (
        <>
        {data.btnType == "link" ? 
        <a href={data.btnLink} target="_blank" className={`footerLink ${data.addClass ? data.addClass : ""}`} disabled={data.disabled ? data.disabled : false} dangerouslySetInnerHTML={{__html:data.contents}}></a>
        :
        <button type="button" className={`footerLink ${data.addClass ? data.addClass : ""}`} onClick={() => data.func()} disabled={data.disabled ? data.disabled : false} dangerouslySetInnerHTML={{__html:data.contents}}></button>
        }
        </>
    );
}

function FooterInfoBox(data){

    return (
        <div className={`footerInfoBox ${data.addClass ? data.addClass : ""}`}>
            {data.children}
        </div>
    );
}

function FooterInfoItem(data){

    return (
        <div className={`footerInfoItem ${data.addClass ? data.addClass : ""}`}>
            <p className="footerInfoItem_name" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className="footerInfoItem_text" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function Footer(data){
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <>
        {pathname == "/" || pathname == "/main" || pathname == "/func" || pathname == "/price" ?
            <div className="footer">
                <div className="footer_section">
                    <div className="footer_header">
                        <img src="/assets/images/footer_logo.svg" onClick={() => { window.location.href = "/" }}/>
                        <div className="footer_linkBox">
                            <FooterLink
                                btnType={null}
                                btnLink={null}
                                contents="Home"
                                func={() => {
                                    navigate("/")
                                }}
                            />
                            <FooterLink
                                btnType={null}
                                btnLink={null}
                                contents="가격정책"
                                func={() => {
                                    navigate("/price")
                                }}
                            />
                            <FooterLink
                                btnType={null}
                                btnLink={null}
                                contents="도입문의"
                                func={() => {
                                    //채널톡 활성화
                                    ChannelShowMessenger();
                                }}
                            />
                        </div>
                    </div>
                    <FooterInfoBox>
                        <FooterInfoItem
                            name="주식회사"
                            text="웨이브코드"
                        />
                        <FooterInfoItem
                            name="대표자"
                            text="박상민"
                        />
                    </FooterInfoBox>
                    <FooterInfoBox>
                        <FooterInfoItem
                            name="사업자등록번호"
                            text="808-87-03227"
                        />
                        <FooterInfoItem
                            name="통신판매업신고번호"
                            text="2024-서울강남-05894"
                        />
                    </FooterInfoBox>
                    <FooterInfoBox>
                        <FooterInfoItem
                            name="대표번호"
                            text="02-6925-6160"
                        />
                        <FooterInfoItem
                            name="이메일"
                            text="welcome@wavecode.io"
                        />
                    </FooterInfoBox>
                    <FooterInfoBox>
                        <FooterInfoItem
                            name="주소"
                            text="서울특별시 강남구 강남대로 484, 6층 616호"
                        />
                    </FooterInfoBox>
                    <div class="footer_box">
                        <p className="footer_caption">Copyright ⓒ 2023 WAVEONE All rights reserved</p>
                        <div className="footer_linkBox">
                            <FooterLink
                                btnType="link"
                                btnLink="https://www.notion.so/WAVEONE-2024-08-23-330360c4ceb240e0a2ebf5277a897703?source=copy_link"
                                contents="서비스 이용약관"
                                func={() => {
                                }}
                            />
                            <FooterLink
                                btnType="link"
                                btnLink="https://www.notion.so/WAVEONE-2024-08-23-502999784b564498b0d5a39358612b10?source=copy_link"
                                contents="개인정보 처리방침"
                                func={() => {
                                }}
                            />
                        </div>
                    </div>
                </div>
                <BtnBox
                    boxType="fixed"
                    addClass="mItem"
                >
                    <BtnItem
                        addClass=""
                        btnType="link"
                        btnLink="https://admin.waveone.team/join"
                        contents={"무료체험 신청"}
                        disabled={false}
                        func={() => {
                        }}
                    />
                </BtnBox>
            </div>
            : ""}
        </>
    );
}

export {Footer}